// Constants for authentication
export const AUTH_COOKIE_NAME = 'airclou_session';
export const AUTH_TOKEN_PARAM = 'token';
export const IMPERSONATION_TOKEN_PARAM = 'impersonation_token';
export const DEFAULT_TOKEN_EXPIRY = 24 * 60 * 60; // 24 hours in seconds
export const DEFAULT_REFRESH_THRESHOLD = 5 * 60; // 5 minutes in seconds
export const COOKIE_OPTIONS = {
    domain: '.airclou.com',
    httpOnly: true,
    secure: true,
    sameSite: 'lax',
    maxAge: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
};
export const SSO_ENDPOINTS = {
    LOGIN: '/sso/login',
    LOGOUT: '/sso/logout',
    ACS: '/saml/acs',
    METADATA: '/saml/metadata',
    SESSION: '/session/me',
};
export const APP_IDS = {
    PLAYBOOK: 'playbook',
    DASHBOARD: 'dashboard',
    FORM_BUILDER: 'form-builder',
};
